// TODO: deprecate
import React, { useState } from 'react'
import PropTypes from 'prop-types'

import ClickAwayListener from '../../ClickAwayListener/ClickAwayListener'
import _ from 'lodash'

import ConfigConsumer from '../../../redux/configuration/context'
import SvgIcon from '../../SvgIcon/SvgIcon'
import { useSelector } from 'react-redux'
import { selectLabels } from '../../../redux/configuration/selectors'
import { renderRouteLabel } from '../utilities'

const FerryRoutesFormSelect = ({
  activeRoute,
  ferryRoutes,
  fieldLabel,
  updateRouteEvent,
  disableToggle
}) => {
  const clientId = process.env.REACT_APP_FLOW_CLIENT_ID
  const [isFieldToggled, toggleField] = useState(false)
  const labels = useSelector(selectLabels)
  let renderOptions = []

  const handleFieldClick = () => {
    if (!disableToggle) {
      toggleField(!isFieldToggled)
    }
  }

  if (!_.isEmpty(ferryRoutes)) {
    for (const routeKey in ferryRoutes) {
      const currentRoute = ferryRoutes[routeKey]
      if (currentRoute.code && currentRoute.description) {
        renderOptions.push(
          <button
            disabled={String(currentRoute.code) === String(activeRoute.code)}
            className={
              clientId === 'mai'
                ? 'ferry-routes__form-select-option btn alt-dropdown-btn'
                : 'ferry-routes__form-select-option btn btn-primary'
            }
            key={'route-option-' + currentRoute.code}
            onClick={() => updateRouteEvent(currentRoute)}
            dangerouslySetInnerHTML={{
              __html: renderRouteLabel(currentRoute, labels)
            }}
          />
        )
      }
    }
  }

  return (
    <ClickAwayListener toggleEvent={toggleField}>
      <div
        className="ferry-routes__form-select"
        onClick={handleFieldClick}
        tabIndex={0}
      >
        <div
          className={`u-form__custom-select ${disableToggle ? 'disabled' : ''}`}
        >
          <p className="u-form__custom-select-label theme-title-variant-seven">
            {fieldLabel}
          </p>
          {activeRoute.description ? (
            <div className="u-form__custom-select-field">
              <p className="select-value">
                <ConfigConsumer>
                  {({ themeVariables }) => (
                    <SvgIcon
                      className="select-value-icon"
                      type="routes"
                      fill={themeVariables.themeIconColor}
                    />
                  )}
                </ConfigConsumer>
                <span
                  dangerouslySetInnerHTML={{
                    __html: renderRouteLabel(activeRoute, labels)
                  }}
                />
              </p>
              {!disableToggle && <p className="select-toggle" />}
            </div>
          ) : (
            <div className="u-form__custom-select-field">
              <p className="select-value">
                <ConfigConsumer>
                  {({ themeVariables }) => (
                    <SvgIcon
                      className="select-value-icon"
                      type="routes"
                      fill={themeVariables.themeIconColor}
                    />
                  )}
                </ConfigConsumer>{' '}
                {labels.selectRoute}{' '}
              </p>
              <p className="select-toggle" />
            </div>
          )}
        </div>
        {isFieldToggled && !_.isEmpty(renderOptions) && (
          <div
            className={
              clientId === 'mai'
                ? 'ferry-routes__form-select-alt-options'
                : 'ferry-routes__form-select-options'
            }
          >
            {renderOptions}
          </div>
        )}
      </div>
    </ClickAwayListener>
  )
}

FerryRoutesFormSelect.propTypes = {
  activeRoute: PropTypes.object.isRequired,
  ferryRoutes: PropTypes.array.isRequired,
  fieldLabel: PropTypes.string,
  toggleLabel: PropTypes.string,
  updateRouteEvent: PropTypes.func.isRequired,
  disableToggle: PropTypes.bool
}

export default FerryRoutesFormSelect
